import React, {useEffect, useState} from "react";
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner';
import {Button} from "react-bootstrap";
import FilterOrder from "../components/FilterOrder/FilterOrder";
import InputGroup from "react-bootstrap/InputGroup";
import { compareOfferWithCell } from '../helpers/utils';
import { sorStartEnd } from '../helpers/utils';
import { sorEndStart } from '../helpers/utils';
import { sorEndStartForProducts } from '../helpers/utils';

export const Products = () => {
    const [state, setState] = useState({
        warehouses: [],
        productsCRM: [],
        products: [],
        loading: true,
    });
    const [source, setSource] = useState('1')
    let negativeArr = []


    useEffect(() => {
        const fetchData = async () => {
            try {
                setState(prevState => ({ ...prevState, loading: true })); // Устанавливаем загрузку

                // Выполняем оба запроса параллельно
                const [offersResponse, productsResponse] = await Promise.all([
                    fetch("/api/offers", {
                        credentials: "include"
                    }),
                    fetch("/api/products", {
                        credentials: "include"
                    })
                ]);

                if (!offersResponse.ok || !productsResponse.ok) {
                    console.error(`Помилка завантаження: offers ${offersResponse.status}, products ${productsResponse.status}`);
                    if (offersResponse.status === 500 || productsResponse.status === 500) {
                        alert("Занадто часто, спробуйте пізніше");
                        throw new Error('Something went wrong.');
                    }
                }

                const [offersData, productsData] = await Promise.all([
                    offersResponse.json(),
                    productsResponse.json()
                ]);

                console.log("offersData", offersData);
                console.log("productsData", productsData);

// Преобразуем productsData (добавляем product_name, убираем product)
                const updatedProductsData = productsData.map(({ product, ...rest }) => ({
                    ...rest,
                    product_name: product?.name || null
                }));

// Создаем карту warehouse
                const warehouseMap = Object.fromEntries(
                    offersData.map(offer => [
                        offer.id,
                        (offer.warehouse || []).map(({ product, ...rest }) => ({
                            ...rest,
                            product_name: product?.name || null
                        }))
                    ])
                );

// Объединяем данные
                const mergedProducts = updatedProductsData.map(product => ({
                    ...product,
                    warehouse: warehouseMap[product.id] || []
                }));

                console.log("mergedProducts", mergedProducts);

                const filteredOffers = offersData.filter(p => p.warehouse.length !== 0);
                const result = filteredOffers.flatMap(el =>
                    el.warehouse.map(w => ({
                        sku: el.sku,
                        idWarehouse: w.id,
                        nameWarehouse: w.name,
                        quantityWarehouse: w.quantity,
                        reserveWarehouse: w.reserve,
                    }))
                );

                let warehouses = result.reduce((a, c) => {
                    let idx = a.findIndex((e) => e[0].idWarehouse === c.idWarehouse);
                    if (idx !== -1) a[idx].push(c);
                    else a.push([c]);
                    return a;
                }, []);

                const filteredProducts = productsData.filter((obj) => obj.is_archived === false);
                let products = filteredProducts.reduce((a, c) => {
                    let idx = a.findIndex((e) => e[0].product_id === c.product_id);
                    if (idx !== -1) a[idx].push(c);
                    else a.push([c]);
                    return a;
                }, []);
                products.sort(sorEndStartForProducts);

                // Обновляем стейт один раз
                setState({
                    warehouses,
                    productsCRM: products,
                    products: productsData,
                    loading: false,  // завантаження завершено
                });
            } catch (error) {
                console.log('Request failed', error);
                setState(prevState => ({ ...prevState, loading: false }));
            }
        };
        fetchData();
    }, []);  // Зависимости пусты, запросы выполняются только один раз


// Использование стейта
    const { warehouses, productsCRM, products, loading } = state;

    if (loading) {
        return <div>Завантаження…</div>;
    }

    const onFilterValueSelected = filterValue => {
        setSource(filterValue)
        let [selectedWarehouseProducts] = warehouses.filter(w => w[0].nameWarehouse === filterValue)
        console.log("selectedWarehouseProducts", selectedWarehouseProducts)
        const result = []
        selectedWarehouseProducts.forEach(swp => {
            products.forEach(p => {
                if (swp.sku === p.sku) result.push({...swp, ...p, quantity: swp.quantityWarehouse, in_reserve: swp.reserveWarehouse})
            })
        })
        console.log("result", result)
        let prods = result.reduce((a, c) => {
            let idx = a.findIndex((e) => e[0].product_id === c.product_id);
            if (idx !== -1) a[idx].push(c);
            else a.push([c]);
            return a;
        }, []);
        prods.sort(sorEndStartForProducts)
        setState(prevState => ({
            ...prevState,         // сохраняем старые значения
            productsCRM: prods,  // обновляем только warehouses
        }));
    }

    let arrSources = []

    warehouses.forEach(w => arrSources.push(w[0].nameWarehouse))


    // const namesAllProducts = []
    // const namesAllProducts = ["Піжама з кантом", "Світшот Paris", "Піжама з воланами", "Кофта з блискавкою", "Труси з рюшами", "Світшот California", "Худі Yale", "Світшот Harvard", "Світшот Yale", 'Блузка муслін', 'Джогери Фліс', 'Джогери двонить', 'Джогери петля 2022', 'Джогери петля 2023', 'Джогери чоловічі', 'Джогери чоловічі 2023', 'Зіпхуді Фліс', 'Зіпхуді петля 2022', 'Зіпхуді петля 2023', 'Карго', 'Карго 2023', 'Комплект білизни', 'Комплект білизни new', 'Комплект білизни new з чашечками', 'Комплект білизни з чашечками', 'Комплект з велосипедками', 'Костюм прошва', 'Купальник бразиліани', 'Купальник квадрат', "Купальник на зав'язках", 'Купальник трикутник', 'Куртка', 'Куртка 2022', 'Лонгслів 2023', 'Лонгслів двонить', 'Лонгслів з віскози', 'Лонгслів на затяжках', 'Лосини', 'Майка', "Майка з зав'язками", 'Майка з кантом', 'Мастерка', 'Прямі штани', 'Рашгард', 'Рукавиці', 'Сарафан льон', 'Світшот Фліс', 'Світшот петля 2021', 'Світшот петля 2022', 'Світшот петля 2023', 'Сорочка джинс', 'Сорочка льон', 'Сорочка льон 2023', 'Сорочка тепла', 'Спідниця джинс', 'Спідниця муслін', 'Сукня', 'Сукня 2023', 'Сукня довга', 'Топ', 'Топ new', 'Топ з чашечками', 'Топ трикутник льон', 'Топ трикутник муслін', "Топ із зав'язками", 'Труси', 'Труси new', 'Туніка на затяжках', 'Футболка Двонитка', 'Футболка Петля', 'Футболка чоловіча', 'Худі Тедді', 'Худі Фліс', 'Худі петля 2021', 'Худі петля 2022', 'Худі петля 2023', 'Худі чоловічі Фліс', 'Шапка', 'Шерпа', 'Шорти двонить', 'Шорти канада', 'Шорти короткі', 'Шорти льон', 'Шорти льон 2023', 'Шорти петля', 'Штани льон', 'Штани льон 2023', 'Штани муслін']
    const namesAllProducts = ['Куртка 2022', 'Лосини', 'Сукня', 'Сукня довга', 'Топ', 'Топ new', 'Топ з чашечками', 'Труси', 'Труси new', 'Худі Тедді', 'Худі петля 2021', 'Худі чоловічі Фліс']
    productsCRM.length && productsCRM.forEach(product => {
        const variantFirst = product[0];
        const name = variantFirst.product.name;
        const isAvailable = !namesAllProducts.includes(name);  // Упростим проверку доступности

        if (isAvailable) {
            product.forEach(offer => {
                let quantity = offer.quantity - offer.in_reserve;
                if (quantity < 0) {
                    // Собираем строку с данными товара
                    const props = offer.properties.map(obj => obj.value).join(" ");
                    const itemStrData = `${offer.product.name}: ${props} ${quantity}`;
                    negativeArr.push(itemStrData);
                }
            });
        }
    });


    const sendToTelegram = async () => {
        const botTOKEN = "bot5346603542:AAFy1TKplf7w8EG2rdVigK-DvXTTjEjWDtg";
        // const chat_id = "-715587093";
        const chat_id = "@lava_expenses"; // LAVA test
        const message = "<b>Речі продані у мінус:</b> \n\n" + negativeArr.map((str, i) => `${negativeArr[i]}`).join("\n")
        await fetch(`https://api.telegram.org/${botTOKEN}/sendMessage?chat_id=${chat_id}&parse_mode=html&text=${encodeURI(message)}`);
    }
    const addSale = async (e) => {
        e.preventDefault()
        await sendToTelegram()
    }

    const renderTableRow = (models, colors, sizes, offers) => {
        return models.map((m, mi) => {
            return colors.map((c, ci) => {
                return (
                    <tr key={ci}>
                        <td rowSpan={colors.length} datamodel={ci}>{m}</td>
                        <td style={{ textAlign: "left" }}>{c}</td>
                        {sizes.map((s, si) => {
                            let quantity = ""
                            offers.forEach(offer => {
                                if (m && c && s) {
                                    const result = compareOfferWithCell(offer.props, [m, c, s])
                                    if (result) {
                                        if (offer.quantity === 0) {
                                            quantity = ""
                                        } else if (offer.in_reserve > 0) {
                                            const available = offer.quantity - offer.in_reserve
                                            quantity = (available === 0) ? "" : available
                                        } else {
                                            quantity = offer.quantity
                                        }
                                    }
                                }
                            })
                            return <td key={si}>{quantity}</td>
                        })}
                    </tr>
                )
            })
        })
    }

    const renderColorRow = (colors, sizes, offers) => {
        return colors.map((c, i) => {
            let isEmpty = true
            return (
                <tr key={i}>
                    <td style={{ textAlign: "left" }}>{c}</td>
                    {sizes.map((s, i) => {
                        let quantity = ""
                        offers.forEach(offer => {
                            if (c && s) {
                                const result = compareOfferWithCell(offer.props, [c, s])
                                if (result) {
                                    if (offer.quantity === 0 && offer.in_reserve === 0) {
                                        quantity = ""
                                    } else if (offer.in_reserve > 0) {
                                        const available = offer.quantity - offer.in_reserve
                                        quantity = (available === 0) ? "" : available
                                    } else {
                                        quantity = offer.quantity
                                    }
                                }
                            }
                        })
                        return <td className={quantity ? "notEmpty" : "empty"} key={i}>{quantity}</td>
                    })}
                </tr>
            )
        })
    }

    const renderAccordionItems = () => {
        return productsCRM.length ? (
            productsCRM.map((product, p) => {
                const offers = product;
                const offerFirst = offers[0]
                const parameters = offerFirst.product.properties_agg
                const total = offerFirst.product.quantity
                const name = offerFirst.product.name
                const isAvailable = !namesAllProducts.includes(name)

                offers.forEach(offer => {
                    let obj = {}
                    let color = ""
                    let model = ""
                    let size = ""

                    offer.properties.forEach((item) => {
                        obj[item.name] = item.value
                    })

                    for (const [key, value] of Object.entries(obj)) {
                        switch (key) {
                            case 'Тип':
                            case 'Модель': model = value; break;
                            case 'Мова':
                            case 'Колір':
                            case 'Color':
                            case 'Koлір': color = value; break;
                            case 'Size':
                            case 'Розмір': size = value; break;
                        }
                    }
                    offer.props = model ? [model, color, size] : [color, size]
                })

                offers.sort(
                    (a, b) => a.props[0].localeCompare(b.props[0]) || a.props[1].localeCompare(b.props[1])
                )

                let colors = [], sizes = [], models = []
                const sizeKeys = ['Розмір', 'Size']
                const colorKeys = ['Мова', 'Колір', 'Color', 'Koлір']
                const modelKeys = ['Тип', 'Модель']

                for (const [key, value] of Object.entries(parameters)) {
                    if (sizeKeys.includes(key)) sizes.push(...value)
                    else if (colorKeys.includes(key)) colors.push(...value)
                    else if (modelKeys.includes(key)) models.push(...value)
                }

                sizes.sort(sorStartEnd)
                colors.sort(sorEndStart)
                models.sort(sorEndStart)

                if (total !== 0 && isAvailable) {
                    return (
                        <Accordion.Item key={p} eventKey={p}>
                            <Accordion.Header>{name}</Accordion.Header>
                            <Accordion.Body>
                                <table className="table table-bordered table-datamodel-hack">
                                    <thead>
                                    <tr>
                                        {models.length ? (
                                            <>
                                                <th style={{ textAlign: "center" }}>Тип</th>
                                                <th>Колір</th>
                                                {sizes.map((s, i) => (
                                                    <th key={i} style={{ textAlign: "center" }}>{s}</th>
                                                ))}
                                            </>
                                        ) : (
                                            <>
                                                <th>Колір</th>
                                                {sizes.map((s, i) => (
                                                    <th key={i} style={{ textAlign: "center" }}>{s}</th>
                                                ))}
                                            </>
                                        )}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {models.length ? renderTableRow(models, colors, sizes, offers) : renderColorRow(colors, sizes, offers)}
                                    </tbody>
                                </table>
                            </Accordion.Body>
                        </Accordion.Item>
                    )
                }
            })
        ) : (
            <div style={{ textAlign: "center" }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )
    }

    return (
        <>
            <header style={{ padding: "1rem 0" }}>
                <div className="container">
                    <div className="inner-header">
                        <h4 style={{ textAlign: "center", marginBottom: 0, textTransform: "uppercase" }}>Склад</h4>
                        <InputGroup className="m-3">
                            <FilterOrder options={arrSources} filterValueSelected={onFilterValueSelected} />
                        </InputGroup>
                        <Button className="m-3" variant="outline-dark" onClick={addSale}>
                            відправити Мінуси
                        </Button>
                    </div>
                </div>
            </header>
            <main style={{ padding: "1rem 0" }}>
                <div className="container">
                    <Accordion defaultActiveKey={'0'} className="lava-accordion">
                        {renderAccordionItems()}
                    </Accordion>
                </div>
            </main>
        </>
    )

}